import { createButton } from 'react-simple-wysiwyg';

import { ReverseLeftIcon } from '@/assets/icons/ReverseLeftIcon';

export default createButton('Undo', <ReverseLeftIcon />, 'undo');
